import { MalpracticeClaim } from '~/types';
import { MalpracticeClaimFormValues } from './types';

const PROVIDER_INVOLVEMENT_OPTIONS_MAPPING: Record<string, number> = {
  'Primary Defendant': 1,
  'Co-defendant': 2,
};

const PROVIDER_INVOLVEMENT_OPTIONS_MAPPING_REVERSE: Record<number, string> = {
  1: 'Primary Defendant',
  2: 'Co-defendant',
};

export const claimFormToApi = (claimForm: MalpracticeClaimFormValues): string => {
  const transformedClaim: MalpracticeClaim = {
    ...claimForm,
    providerInvolvement: PROVIDER_INVOLVEMENT_OPTIONS_MAPPING[claimForm.providerInvolvement.value],
    claimStatus: claimForm.claimStatus.value,
    settlementAmt:
      claimForm.settlementAmt || claimForm.settlementAmt === 0 ? claimForm.settlementAmt : null,
    settlementDate: claimForm.settlementDate ? claimForm.settlementDate : null,
  };
  return JSON.stringify(transformedClaim);
};

export const claimApiToForm = (malpracticeClaim: string): MalpracticeClaimFormValues => {
  const parsed: MalpracticeClaim = JSON.parse(malpracticeClaim);

  // AI-parsed records may return null for fields the form requires.
  // Explicit guards override spread values for at-risk fields.
  const involvement = parsed.providerInvolvement
    ? PROVIDER_INVOLVEMENT_OPTIONS_MAPPING_REVERSE[parsed.providerInvolvement]
    : '';

  return {
    ...parsed,
    liabilityCarrier: parsed.liabilityCarrier ?? '',
    allegationsTxt: parsed.allegationsTxt ?? '',
    allegedInjuryTxt: parsed.allegedInjuryTxt ?? '',
    occurrenceDate: parsed.occurrenceDate ?? '',
    claimDate: parsed.claimDate ?? '',
    details: parsed.details ?? '',
    providerInvolvement: {
      label: involvement ?? '',
      value: involvement ?? '',
    },
    claimStatus: parsed.claimStatus
      ? { label: parsed.claimStatus, value: parsed.claimStatus }
      : { label: '', value: '' },
    validFlag: true,
    warnings: {},
  };
};

export const claimsApiToForm = (malpracticeClaims: string): MalpracticeClaimFormValues[] => {
  const parsed = JSON.parse(malpracticeClaims);
  return parsed.map((malpracticeClaim: MalpracticeClaim) =>
    claimApiToForm(JSON.stringify(malpracticeClaim))
  );
};

export const errorHandler = (message: string, err: unknown) => {
  // TODO: MCV-140 - We need a design on how we want to handle errors and how the user is notified.
  console.error(message, err);
};
